// Product accordion popups (collapsible_tab "See all ingredients" modal).
//
// Originally lived as an inline <script> inside main-product.liquid's
// {%- when 'collapsible_tab' -%} branch — meaning it emitted once per
// accordion block. A 5-accordion PDP wired ~25 document-level click
// listeners + 5 keydown listeners, all running on every click.
//
// Extracted to this single asset, loaded once per PDP via <script src
// defer> in main-product.liquid. The handlers are document-delegated so
// one copy covers all accordions on the page.
//
// featured-product.liquid and homepage-product-switcher.liquid load this
// file as well; the `window.__productAccordionPopupBound` flag keeps one
// copy wired on a page that carries more than one of them.

(function () {
  if (window.__productAccordionPopupBound) return;
  window.__productAccordionPopupBound = true;

  function openPopup(popupId, opener) {
    var popup = document.getElementById(popupId);
    if (!popup) return;
    popup.__accordionPopupOpener = opener || null;
    popup.classList.add('active');

    var closeButton = popup.querySelector('.accordion-popup-close');
    if (closeButton) {
      setTimeout(function () { closeButton.focus(); }, 100);
    }
  }

  function closePopup(popup) {
    if (!popup) return;
    // Give focus back to the link that opened the popup before hiding it. Focus is
    // on the close button or the scrolling body (data-scroll-region), and hiding
    // either drops it to <body>, so a keyboard user's next Tab started over at the
    // top of the page. A click on the backdrop leaves focus alone: it is already on
    // <body> by then.
    var opener = popup.__accordionPopupOpener;
    if (opener && opener.isConnected && popup.contains(document.activeElement)) {
      opener.focus({ preventScroll: true });
    }
    popup.classList.remove('active');
  }

  // Intercept clicks on "See All Ingredients" links inside accordion content.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a');
    if (!link) return;
    if (link.textContent.toLowerCase().indexOf('see all ingredients') === -1) return;
    var accordionContent = link.closest('.accordion__content');
    if (!accordionContent) return;
    var popup = accordionContent.querySelector('.accordion-popup-overlay');
    if (!popup) return;
    e.preventDefault();
    openPopup(popup.id, link);
  });

  // Close popup when clicking the close button.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.accordion-popup-close')) return;
    e.preventDefault();
    e.stopPropagation();
    closePopup(e.target.closest('.accordion-popup-overlay'));
  });

  // Close popup when clicking outside the content (on overlay).
  document.addEventListener('click', function (e) {
    if (
      e.target.classList.contains('accordion-popup-overlay') &&
      e.target.classList.contains('active')
    ) {
      closePopup(e.target);
    }
  });

  // Close popup with Escape key.
  var swallowEscapeUp = false;
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var activePopup = document.querySelector('.accordion-popup-overlay.active');
    if (!activePopup) return;
    closePopup(activePopup);
    swallowEscapeUp = true;
  });

  // One Escape closes the popup and nothing else. Dawn closes any open
  // <details id="Details-..."> on Escape keyup (global.js onKeyUpEscape), and by
  // keyup focus is back on the link inside the accordion, so the same press would
  // collapse the accordion as well. Stop that keyup before it reaches the details.
  document.addEventListener(
    'keyup',
    function (e) {
      if (e.key !== 'Escape' || !swallowEscapeUp) return;
      swallowEscapeUp = false;
      e.stopPropagation();
    },
    true
  );
})();
